import { render, staticRenderFns } from "./ClinicEntities.vue?vue&type=template&id=ca1326f8&"
import script from "./ClinicEntities.vue?vue&type=script&lang=js&"
export * from "./ClinicEntities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports